import { EmployeeStatus } from '@seapoint/server/enums';
import { z } from 'zod';

// Personal Information Validation Schema
export const personalInformationSchema = z.object({
  firstName: z.string().trim().min(1, 'First name is required').max(50, 'First name must be less than 50 characters'),
  lastName: z.string().trim().min(1, 'Last name is required').max(50, 'Last name must be less than 50 characters'),
  status: z.nativeEnum(EmployeeStatus, { message: 'Employee status is required' }),
});

export type PersonalInformationFormValues = z.infer<typeof personalInformationSchema>;
